var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g2, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _g3, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _g4, _path82, _path83, _path84, _path85, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgL102Layouts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 220,
    viewBox: "0 0 280 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_162)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.31 43.09H55.23C50.69 43.09 47.01 46.77 47.01 51.31V143.59H224.99V51.32C224.99 46.78 221.31 43.1 216.77 43.1H90.61",
    fill: "#F1F5F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.31 43.09H55.23C50.69 43.09 47.01 46.77 47.01 51.31V143.59H224.99V51.32C224.99 46.78 221.31 43.1 216.77 43.1H90.61",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.21 119.69C35.21 117.56 33.05 115.4 30.92 115.4C33.05 115.4 35.21 113.24 35.21 111.11C35.21 113.24 37.37 115.4 39.5 115.4C37.37 115.4 35.21 117.56 35.21 119.69Z",
    stroke: "#FBDF47",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.21 119.69C35.21 117.56 33.05 115.4 30.92 115.4C33.05 115.4 35.21 113.24 35.21 111.11C35.21 113.24 37.37 115.4 39.5 115.4C37.37 115.4 35.21 117.56 35.21 119.69Z",
    stroke: "#FBDF47",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.01 143.59V159.89C47.01 164.43 50.69 168.11 55.23 168.11H216.76C221.3 168.11 224.98 164.43 224.98 159.89V143.59H47.01Z",
    fill: "#CBD5E1",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.1 191.11H106.89L113.83 168.11H158.16L165.1 191.11Z",
    fill: "#CBD5E1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_162",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 168,
    width: 60,
    height: 24
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M165.1 191.11H106.89L113.83 168.11H158.16L165.1 191.11Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.06 159.72H109.09V173.22H165.06V159.72Z",
    fill: "#94A3B8"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.1 191.11H106.89L113.83 168.11H158.16L165.1 191.11Z",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M218.16 162.57L87.3125 162.57",
    stroke: "#F1F5F9",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M82.36 162.57L79 162.57",
    stroke: "#F1F5F9",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.63 133.14H124.03C125.687 133.14 127.03 131.797 127.03 130.14V79.04C127.03 77.3832 125.687 76.04 124.03 76.04H64.63C62.9731 76.04 61.63 77.3832 61.63 79.04V130.14C61.63 131.797 62.9731 133.14 64.63 133.14Z",
    fill: "#C9D0E9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M103.27 104.61H85.9",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M94.59 113.29V95.92",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M127.03 94.39V114.83",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.22 94.39V114.83",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M127.03 87.28V79.1C127.03 77.41 125.66 76.03 123.96 76.03H115.78",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M104.81 76.04H84.37",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.14 87.28V79.1C62.14 77.41 63.51 76.03 65.21 76.03H73.39",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M127.03 121.93V130.11C127.03 131.8 125.66 133.18 123.96 133.18H115.78",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M104.81 133.17H84.37",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M62.14 121.93V130.11C62.14 131.8 63.51 133.18 65.21 133.18H73.39",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M143.04 133.14H202.47C205.12 133.14 206.45 131.95 206.45 133.14V102.57C206.45 98.43 205.11 97.23 202.47 97.23H143.04C142.39 97.23 141.05 98.42 141.05 102.57V133.14C141.05 131.95 142.39 133.14 143.04 133.14Z",
    fill: "#C9D0E9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M206.46 113.64V119.45",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M141.65 113.64V119.45",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M206.46 107.29V99.9801C206.46 98.4701 205.09 97.2401 203.39 97.2401H196.21",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M169.15 97.2401H159.54",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M141.56 107.29V99.9801C141.56 98.4701 142.93 97.2401 144.63 97.2401H150.81",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M206.46 125.8V130.44C206.46 131.95 205.09 133.18 203.39 133.18H196.21",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M169.15 133.17H159.54",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M188.04 97.2401H178.44",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M188.04 133.17H178.44",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M141.56 125.8V130.44C141.56 131.95 142.93 133.18 144.63 133.18H150.81",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M211.77 52.92H60.22C58.5631 52.92 57.22 54.2632 57.22 55.92V63.86C57.22 65.5169 58.5631 66.86 60.22 66.86H211.77C213.427 66.86 214.77 65.5169 214.77 63.86V55.92C214.77 54.2632 213.427 52.92 211.77 52.92Z",
    fill: "#9889C0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_162",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 52,
    width: 158,
    height: 15
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M211.77 52.92H60.22C58.5631 52.92 57.22 54.2632 57.22 55.92V63.86C57.22 65.5169 58.5631 66.86 60.22 66.86H211.77C213.427 66.86 214.77 65.5169 214.77 63.86V55.92C214.77 54.2632 213.427 52.92 211.77 52.92Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.2 62.6301H53.92V70.8401H201.2V62.6301Z",
    fill: "#7663AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.25 52.17H210.04V59.64C210.04 61.29 208.7 62.63 207.05 62.63H201.2V70.84H213.52V64.49H218.25V52.17Z",
    fill: "#7663AA"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M211.77 52.92H60.22C58.5631 52.92 57.22 54.2632 57.22 55.92V63.86C57.22 65.5169 58.5631 66.86 60.22 66.86H211.77C213.427 66.86 214.77 65.5169 214.77 63.86V55.92C214.77 54.2632 213.427 52.92 211.77 52.92Z",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M65.31 62.13C66.5471 62.13 67.55 61.1271 67.55 59.89C67.55 58.6529 66.5471 57.65 65.31 57.65C64.0729 57.65 63.07 58.6529 63.07 59.89C63.07 61.1271 64.0729 62.13 65.31 62.13Z",
    fill: "#0F172A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M73.52 62.13C74.7571 62.13 75.76 61.1271 75.76 59.89C75.76 58.6529 74.7571 57.65 73.52 57.65C72.2829 57.65 71.28 58.6529 71.28 59.89C71.28 61.1271 72.2829 62.13 73.52 62.13Z",
    fill: "#0F172A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M81.74 62.13C82.9771 62.13 83.98 61.1271 83.98 59.89C83.98 58.6529 82.9771 57.65 81.74 57.65C80.5029 57.65 79.5 58.6529 79.5 59.89C79.5 61.1271 80.5029 62.13 81.74 62.13Z",
    fill: "#0F172A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M200.58 52.8V66.4801",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M163.39 76.0801H206.43",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M163.39 86.3801H206.43",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M148.49 86.89C152.179 86.89 155.17 83.8993 155.17 80.21C155.17 76.5208 152.179 73.53 148.49 73.53C144.801 73.53 141.81 76.5208 141.81 80.21C141.81 83.8993 144.801 86.89 148.49 86.89Z",
    fill: "#FBDF47",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M168.4 187.82H102C100.64 187.82 99.45 188.74 99.11 190.05L98.03 194.2C97.87 194.83 98.34 195.45 98.99 195.45H171.41C172.06 195.45 172.54 194.83 172.37 194.2L171.29 190.05C170.95 188.73 169.76 187.82 168.4 187.82Z",
    fill: "#94A3B8",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M265 24.55H213.82C211.059 24.55 208.82 26.7886 208.82 29.55V66.67C208.82 69.4315 211.059 71.67 213.82 71.67H265C267.761 71.67 270 69.4315 270 66.67V29.55C270 26.7886 267.761 24.55 265 24.55Z",
    fill: "#FBDF47"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_162",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 208,
    y: 24,
    width: 62,
    height: 48
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M265 24.55H213.82C211.059 24.55 208.82 26.7886 208.82 29.55V66.67C208.82 69.4315 211.059 71.67 213.82 71.67H265C267.761 71.67 270 69.4315 270 66.67V29.55C270 26.7886 267.761 24.55 265 24.55Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_162)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M265.69 22.3201V65.3301C265.69 66.4701 264.77 67.3901 263.63 67.3901H206.61V81.2101L272.32 80.6001V22.3201H265.68H265.69Z",
    fill: "#FBDF47"
  })))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M265 24.55H213.82C211.059 24.55 208.82 26.7886 208.82 29.55V66.67C208.82 69.4315 211.059 71.67 213.82 71.67H265C267.761 71.67 270 69.4315 270 66.67V29.55C270 26.7886 267.761 24.55 265 24.55Z",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M216.18 61.92H262.54",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M221.27 46.0701H228.39C228.94 46.0701 229.39 46.5201 229.39 47.0701V61.9201H220.27V47.0701C220.27 46.5201 220.72 46.0701 221.27 46.0701Z",
    fill: "#EE405F",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M235.8 40.9701H242.92C243.47 40.9701 243.92 41.4201 243.92 41.9701V61.9201H234.8V41.9701C234.8 41.4201 235.25 40.9701 235.8 40.9701Z",
    fill: "#46C4E1",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M250.32 34.3H257.44C257.99 34.3 258.44 34.75 258.44 35.3V61.92H249.32V35.3C249.32 34.75 249.77 34.3 250.32 34.3Z",
    fill: "#F27421",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M238.19 137.58L177.52 116.38C175.95 115.83 174.43 117.34 174.98 118.92L196.18 179.59C196.7 181.07 198.65 181.4 199.62 180.17L211.93 164.6L232.39 185.06C233.17 185.84 234.43 185.84 235.21 185.06L243.66 176.61C244.44 175.83 244.44 174.57 243.66 173.79L223.2 153.33L238.77 141.02C240 140.05 239.67 138.1 238.19 137.58Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_162",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 174,
    y: 116,
    width: 71,
    height: 70
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M238.19 137.58L177.52 116.38C175.95 115.83 174.43 117.34 174.98 118.92L196.18 179.59C196.7 181.07 198.65 181.4 199.62 180.17L211.93 164.6L232.39 185.06C233.17 185.84 234.43 185.84 235.21 185.06L243.66 176.61C244.44 175.83 244.44 174.57 243.66 173.79L223.2 153.33L238.77 141.02C240 140.05 239.67 138.1 238.19 137.58Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.19 136.17L177.52 114.97C175.95 114.42 174.43 115.93 174.98 117.51L196.18 178.18C196.7 179.66 198.65 179.99 199.62 178.76L211.93 163.19L232.39 183.65C233.17 184.43 234.43 184.43 235.21 183.65L243.66 175.2C244.44 174.42 244.44 173.16 243.66 172.38L223.2 151.92L238.77 139.61C240 138.64 239.67 136.69 238.19 136.17Z",
    stroke: "#CBD5E1",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M238.19 137.58L177.52 116.38C175.95 115.83 174.43 117.34 174.98 118.92L196.18 179.59C196.7 181.07 198.65 181.4 199.62 180.17L211.93 164.6L232.39 185.06C233.17 185.84 234.43 185.84 235.21 185.06L243.66 176.61C244.44 175.83 244.44 174.57 243.66 173.79L223.2 153.33L238.77 141.02C240 140.05 239.67 138.1 238.19 137.58Z",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M190.71 146.65L189.75 143.88",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M198.66 169.38L192.28 151.13",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M170.56 121.99L166.25 126.29",
    stroke: "#020617",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M185.1 107.44L180.8 111.75",
    stroke: "#020617",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M167.56 116.14L160.8 115.46",
    stroke: "#020617",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M169.23 110.68L163.97 105.42",
    stroke: "#020617",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M174.59 108.81L173.92 102.05",
    stroke: "#020617",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M249.54 117.23H255.76",
    stroke: "#D7ACD0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M252.65 114.15V120.37",
    stroke: "#D7ACD0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M19.68 105.78H24.67",
    stroke: "#80D1E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M22.18 103.31V108.3",
    stroke: "#80D1E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M248.95 98.73C250.646 98.73 252.02 97.3555 252.02 95.66C252.02 93.9645 250.646 92.59 248.95 92.59C247.254 92.59 245.88 93.9645 245.88 95.66C245.88 97.3555 247.254 98.73 248.95 98.73Z",
    stroke: "#EB74AC",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M20.99 126.11C22.2382 126.11 23.25 125.098 23.25 123.85C23.25 122.602 22.2382 121.59 20.99 121.59C19.7418 121.59 18.73 122.602 18.73 123.85C18.73 125.098 19.7418 126.11 20.99 126.11Z",
    fill: "#D7ACD0"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M235.91 110.57C236.838 110.57 237.59 109.818 237.59 108.89C237.59 107.962 236.838 107.21 235.91 107.21C234.982 107.21 234.23 107.962 234.23 108.89C234.23 109.818 234.982 110.57 235.91 110.57Z",
    fill: "#56BE92"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M29.65 37.9901H63.29C66.21 37.9901 68.57 40.3501 68.57 43.2701V77.9801C68.57 80.9001 66.21 83.2601 63.29 83.2601H15.33C12.39 83.2601 10 80.8801 10 77.9301V43.2601C10 40.3401 12.36 37.9801 15.28 37.9801H31.16",
    fill: "#E2F2FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_162",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 37,
    width: 59,
    height: 47
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M29.65 37.9901H63.29C66.21 37.9901 68.57 40.3501 68.57 43.2701V77.9801C68.57 80.9001 66.21 83.2601 63.29 83.2601H15.33C12.39 83.2601 10 80.8801 10 77.9301V43.2601C10 40.3401 12.36 37.9801 15.28 37.9801H31.16",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_162)"
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84 84.3801L26.62 59.3201C28.67 57.0701 32.18 56.9901 34.33 59.1401L44.29 69.1001L46.93 66.4601C49.01 64.3801 52.38 64.3801 54.46 66.4601L72.39 84.3901H3.84V84.3801Z",
    fill: "#56BE92",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M64.48 31.6301V74.6401C64.48 75.7801 63.56 76.7001 62.42 76.7001H5.41V90.5201L78.3 89.9101V31.6401H64.48V31.6301Z",
    fill: "#020617"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M52.54 53.5201C54.2687 53.5201 55.67 52.1188 55.67 50.3901C55.67 48.6615 54.2687 47.2601 52.54 47.2601C50.8113 47.2601 49.41 48.6615 49.41 50.3901C49.41 52.1188 50.8113 53.5201 52.54 53.5201Z",
    fill: "#020617"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M29.65 37.9901H63.29C66.21 37.9901 68.57 40.3501 68.57 43.2701V77.9801C68.57 80.9001 66.21 83.2601 63.29 83.2601H15.33C12.39 83.2601 10 80.8801 10 77.9301V43.2601C10 40.3401 12.36 37.9801 15.28 37.9801H31.16",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M45.81 138.53H70.63C72.6 138.53 74.19 140.62 74.19 143.19V179.43C74.19 182 72.59 184.09 70.63 184.09H32.68C30.71 184.09 29.12 182 29.12 179.43V143.19C29.12 140.62 30.72 138.53 32.68 138.53H45.81Z",
    fill: "#BFD865"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_162",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 138,
    width: 46,
    height: 47
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M45.81 138.53H70.63C72.6 138.53 74.19 140.62 74.19 143.19V179.43C74.19 182 72.59 184.09 70.63 184.09H32.68C30.71 184.09 29.12 182 29.12 179.43V143.19C29.12 140.62 30.72 138.53 32.68 138.53H45.81Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_162)"
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M41.77 170.66H60.83C65.4 170.66 69.11 174.37 69.11 178.94V188.77H33.5V178.94C33.5 174.37 37.21 170.66 41.78 170.66H41.77Z",
    fill: "#F17171",
    stroke: "#020617",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M39.02 178.21V188.23",
    stroke: "#020617",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M63.15 178.21V188.23",
    stroke: "#020617",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M52.08 142.61H50.52C45.0082 142.61 40.54 147.078 40.54 152.59V159.36C40.54 164.872 45.0082 169.34 50.52 169.34H52.08C57.5918 169.34 62.06 164.872 62.06 159.36V152.59C62.06 147.078 57.5918 142.61 52.08 142.61Z",
    fill: "#FFB69D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1_162",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 142,
    width: 23,
    height: 28
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M52.08 142.61H50.52C45.0082 142.61 40.54 147.078 40.54 152.59V159.36C40.54 164.872 45.0082 169.34 50.52 169.34H52.08C57.5918 169.34 62.06 164.872 62.06 159.36V152.59C62.06 147.078 57.5918 142.61 52.08 142.61Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1_162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.94 128.21C62.5 128.21 58.68 130.9 57.04 134.75C55.4 130.91 51.58 128.21 47.14 128.21C41.2 128.21 36.38 133.03 36.38 138.97V144.18C36.38 150.12 41.2 154.94 47.14 154.94C51.58 154.94 55.4 152.25 57.04 148.4C58.68 152.24 62.5 154.94 66.94 154.94C72.88 154.94 77.7 150.12 77.7 144.18V138.97C77.7 133.03 72.88 128.21 66.94 128.21Z",
    fill: "#844F20",
    stroke: "#020617",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M52.08 142.61H50.52C45.0082 142.61 40.54 147.078 40.54 152.59V159.36C40.54 164.872 45.0082 169.34 50.52 169.34H52.08C57.5918 169.34 62.06 164.872 62.06 159.36V152.59C62.06 147.078 57.5918 142.61 52.08 142.61Z",
    stroke: "#020617",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M45.81 138.53H70.63C72.6 138.53 74.19 140.62 74.19 143.19V179.43C74.19 182 72.59 184.09 70.63 184.09H32.68C30.71 184.09 29.12 182 29.12 179.43V143.19C29.12 140.62 30.72 138.53 32.68 138.53H45.81Z",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M70.33 147.25V170.04",
    stroke: "#EBF1C9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M70.33 144.02V142.53",
    stroke: "#EBF1C9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 220,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgL102Layouts);
export default __webpack_public_path__ + "static/media/L1_02_Layouts.c5468aaca5f26cbd919657b9a1609dcc.svg";
export { ForwardRef as ReactComponent };